import React from 'react';
import PropTypes from 'prop-types';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';
import IconFacebook from 'components/icons/IconFacebook';
import IconLinkedin from 'components/icons/IconLinkedin';
import IconTwitter from 'components/icons/IconTwitter';

const styles = () => ({
  typography: {
    marginBottom: 16,
  },
  icon: {
    width: 20,
    height: 20,
    margin: '0 8px -3px 0 ',
  },
});

const ShareSocialNetworksNavigation = ({
  className,
  onShareButtonClick,
  shareUrl,
  shareTitle,
  classes,
}) => (
  <div className={className}>
    <Typography
      className={classes.typography}
      color="secondary"
      align="center"
    >
      Share via Social Networks
    </Typography>
    <Grid
      container
      justify="space-around"
      spacing={24}
    >
      <Grid item>
        <FacebookShareButton
          beforeOnClick={onShareButtonClick}
          url={shareUrl}
          quote={shareTitle}
        >
          <Link
            size="md"
            color="primary"
          >
            <IconFacebook className={classes.icon} />
            Facebook
          </Link>
        </FacebookShareButton>
      </Grid>
      <Grid item>
        <LinkedinShareButton
          beforeOnClick={onShareButtonClick}
          url={shareUrl}
          title={shareTitle}
          windowWidth={750}
          windowHeight={600}
        >
          <Link
            size="md"
            color="primary"
          >
            <IconLinkedin className={classes.icon} />
            LinkedIn
          </Link>
        </LinkedinShareButton>
      </Grid>
      <Grid item>
        <TwitterShareButton
          beforeOnClick={onShareButtonClick}
          url={shareUrl}
          title={shareTitle}
        >
          <Link
            size="md"
            color="primary"
          >
            <IconTwitter className={classes.icon} />
            Twitter
          </Link>
        </TwitterShareButton>
      </Grid>
    </Grid>
  </div>
);

ShareSocialNetworksNavigation.propTypes = {
  className: PropTypes.string,
  shareUrl: PropTypes.string.isRequired,
  shareTitle: PropTypes.string.isRequired,
  onShareButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

ShareSocialNetworksNavigation.defaultProps = {
  className: '',
  onShareButtonClick: () => {},
  shareUrl: 'http://dmefordme.com',
  shareTitle: 'DMEforDME - Electronic health managment platform for doctors and patients',
};

export default withStyles(styles)(ShareSocialNetworksNavigation);



// WEBPACK FOOTER //
// ./src/components/common/ShareDialog/ShareSocialNetworksNavigation.js